/*
  fav-board.js — Favoritten.dk

  Ankomsttavlen i hero'en. Tavlen staar allerede i markup med foerste
  besked paa klapperne; scriptet skifter bare mellem beskederne.

  Staar helt stille ved reduceret bevaegelse. Holder pause naar tavlen
  er uden for skaermen eller fanen er skjult, saa den ikke bruger
  stroem paa at klappe for ingen.
*/
(function () {
  'use strict';

  var stille = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INTERVAL = 4200;   /* tid mellem beskeder */
  var FORSKUD  = 60;     /* forsinkelse fra klap til klap, venstre mod hoejre */
  var KLAPTID  = 420;    /* skal matche de to 0,2s-animationer i CSS'en */

  function init(tavle) {
    if (tavle.__favBoard) return;
    tavle.__favBoard = true;
    if (stille) return;

    var linjer;
    try { linjer = JSON.parse(tavle.getAttribute('data-lines') || '[]'); } catch (e) { return; }
    if (!linjer || linjer.length < 2) return;

    var klapper = [].slice.call(tavle.querySelectorAll('.fav-hv2__tile'));
    var n = klapper.length;
    if (!n) return;

    klapper.forEach(function (k) {
      k.insertAdjacentHTML('beforeend',
        '<span class="fav-hv2__half fav-hv2__half--ftop"><b></b></span>' +
        '<span class="fav-hv2__half fav-hv2__half--fbot"><b></b></span>');
      k._top  = k.querySelector('.fav-hv2__half--top b');
      k._bund = k.querySelector('.fav-hv2__half--bot b');
      k._ftop = k.querySelector('.fav-hv2__half--ftop b');
      k._fbnd = k.querySelector('.fav-hv2__half--fbot b');
    });

    /* Array.from deler efter tegn, ikke efter UTF-16-enheder, saa Æ, Ø
       og Å ikke kan havne halvt paa hver sin klap. */
    function tegn(s) {
      var a = Array.from(String(s).toUpperCase());
      while (a.length < n) a.push(' ');
      return a.slice(0, n);
    }

    function klap(k, ny) {
      var gammel = k._top.textContent;
      if (gammel === ny) return;
      k._ftop.textContent = gammel;   /* falder ned og skjuler det nye */
      k._fbnd.textContent = ny;       /* folder sig op over det gamle  */
      k._top.textContent  = ny;
      k.classList.remove('is-flip');
      void k.offsetWidth;             /* genstart animationen */
      k.classList.add('is-flip');
      setTimeout(function () {
        k._bund.textContent = ny;
        k.classList.remove('is-flip');
      }, KLAPTID);
    }

    function vis(besked) {
      var t = tegn(besked);
      klapper.forEach(function (k, i) {
        setTimeout(function () { klap(k, t[i]); }, i * FORSKUD);
      });
    }

    var nr = 0;
    var synlig = true;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (poster) {
        synlig = poster[0].isIntersecting;
      }).observe(tavle);
    }

    setInterval(function () {
      if (!synlig || document.hidden || !tavle.isConnected) return;
      nr = (nr + 1) % linjer.length;
      vis(linjer[nr]);
    }, INTERVAL);
  }

  function start(rod) {
    (rod || document).querySelectorAll('.fav-hv2__board[data-lines]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* Temaeditoren genindlaeser sektionen uden at genindlaese siden. */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
